function getTimeRemaining(endtime) {
    var dateTime = endtime.split(' ');
    var date = dateTime[0].split('-');
    var yyyy = date[0];
    var mm = date[1] - 1; // remove 1 from the month
    var dd = date[2];

    var time = dateTime[1].split(':');
    var h = time[0];
    var m = time[1];
    var s = time[2];

    endtime = new Date(yyyy, mm, dd, h, m, s);

    var timeRemaining = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((timeRemaining / 1000) % 60);
    var minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    return {
        'total': parseFloat((timeRemaining < 10 ? '0' + timeRemaining : timeRemaining)),
        'days': parseFloat((days < 10 ? '0' + days : days)),
        'hours': parseFloat((hours < 10 ? '0' + hours : hours)),
        'minutes': parseFloat((minutes < 10 ? '0' + minutes : minutes)),
        'seconds': parseFloat((seconds < 10 ? '0' + seconds : seconds))
    };
}
if ($('.project-time-left').length) {
    var timer = $('.project-time-left');
    var countdown = timer.attr('data-end_date');
    // var degreees = 0;

    var timerInterval = setInterval(function () {
        var time = getTimeRemaining(countdown);

        if (time.total <= 0) {
            // show the end time
            clearInterval(timerInterval);

            // remvoe the donation options and put in the thank you message
            // $('.thank-you-outer-wrapper').show();
            // $('.donation-outer-wrapper').remove();
        }

        timer.find('[data-input="days"]').html(time.days);
        timer.find('[data-input="hours"]').html(time.hours);
        timer.find('[data-input="minutes"]').html(time.minutes);
        timer.find('[data-input="seconds"]').html(time.seconds);

        // // update the seconds
        // if (degreees === 0) {
        //     degreees = (60 - time.seconds) * 6;
        // } else {
        //     degreees += 6;
        // }
        // $('.clock .seconds').css({
        //     'transform': `rotate(${degreees}deg)`
        // });

        // // minutes 
        // var minutes = 60 - time.minutes;
        // var clock = $('.clock');
        // var circumference = parseFloat(clock.find('.minutes').attr('stroke-dasharray'));
        // var dashoffset = circumference * (1 - ((minutes * 1.6666666667) / 100));
        // clock.find('.minutes').css({ strokeDashoffset: dashoffset + '' });


    }, 1000);
}